<template>
  <div class="invoice-form">
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <div class="form-row">
        <el-form-item label="单位名称" prop="fDw">
          <el-input v-model="form.fDw" />
        </el-form-item>
        <el-form-item label="社会统一信用代码" prop="fShNumber">
          <el-input v-model="form.fShNumber" />
        </el-form-item>

      </div>
      <div class="form-row">
        <el-form-item label="地址" prop="fAddress">
          <el-input v-model="form.fAddress" />
        </el-form-item>
        <el-form-item label="电话" prop="fPhone">
          <el-input v-model="form.fPhone" />
        </el-form-item>

      </div>
      <div class="form-row">
        <el-form-item label="开户行名称" prop="fBankName">
          <el-input v-model="form.fBankName" />
        </el-form-item>
        <el-form-item label="开户行账号" prop="fBankNumber">
          <el-input v-model="form.fBankNumber" />
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="发票邮寄地址" prop="fAddress_fp">
          <el-input v-model="form.fAddress_fp" />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fDw: [{ required: true, message: '必填项', trigger: 'change' }],
        fShNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress: [{ required: true, message: '必填项', trigger: 'change' }],
        fPhone: [{ required: true, message: '必填项', trigger: 'change' }],
        fBankName: [{ required: true, message: '必填项', trigger: 'change' }],
        fBankNumber: [{ required: true, message: '必填项', trigger: 'change' }],
        fAddress_fp: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less'>
.invoice-form{
.el-form{
  display: flex;
flex-direction:column;
   .form-row{
      display: flex;
    flex-direction:row;
    & div{
   flex:1;
    }
  }
}

}
</style>
